import { Box, Flex, VStack } from '@chakra-ui/react';
import type React from 'react';
import FaceliftRadioGroup from '@/components/Atoms/FaceliftRadioGroup';
import FaceliftText from '@/components/Atoms/FaceliftText';
import type { ReturnOrderFormData } from '@/components/Templates/Returns/ReturnOrderForm/types';
import type { FormMethods } from '@/types/form';

export interface ComplianceChecklistProps {
	formMethods: FormMethods<ReturnOrderFormData>;
}

const ComplianceChecklist: React.FC<ComplianceChecklistProps> = ({
	formMethods,
}) => {
	const { watch, setValue, errors } = formMethods;

	const questions = [
		{
			field: 'ta_hastheproductbeeninyourpossessionupon' as const,
			question: 'Has the product been in your possession since receiving it?',
		},
		{
			field: 'ta_hastheproductbeenstoredaccordingtothemanu' as const,
			question: "Has the product been stored according to the manufacturer's specifications?",
		},
		{
			field: 'ta_hastheproductbeensecurelystoredbyauthoriz' as const,
			question: 'Has the product been securely stored by authorized clinicians?',
		},
		{
			field: 'ta_hasanyproductbeenusedoropen' as const,
			question: 'Has any product been used or open?',
		},
		{
			field: 'ta_istheproductintheoriginalunmarkedandundam' as const,
			question: 'Is the product in the original unmarked and undamaged packaging?',
		},
	];

	const radioItems = [
		{ label: 'Yes', value: 'true' },
		{ label: 'No', value: 'false' },
	];

	return (
		<Box mb={-8}>
			<FaceliftText
				fontSize={{ base: 'sm', md: 'md' }}
				fontWeight="semibold"
				mb={{ base: 4, md: 6 }}
				fontStyle="italic"
			>
				Please Complete to the best of your knowledge.
			</FaceliftText>

		<VStack gap={2} align="stretch" mx={2} mb={8}>
			{questions.map((item, index) => (
				<Flex key={item.field} justify="space-between" align="center">
					<FaceliftText fontWeight="normal" flex={1}>
						{index + 1}. {item.question}
					</FaceliftText>
					<Box ml={4}>
						<FaceliftRadioGroup
							value={
								watch(item.field) === true
									? 'true'
									: watch(item.field) === false
										? 'false'
										: null
							}
							onValueChange={(value) => setValue(item.field, value === 'true', { shouldValidate: true })}
							items={radioItems}
							gap={4}
							error={errors?.[item.field]?.message}
						/>
					</Box>
				</Flex>
			))}
		</VStack>
		</Box>
	);
};

export default ComplianceChecklist;

